import "@babel/polyfill";
import imageCarousel from "./carousel";
import initMap from "./map";
import menuAnimation from "./menuanimation";
import scrollAnimations from "./scrollanimations";
import initCalc from "./calculator";
import triggerLeavingPopUp from "./leavingPopUp";
import triggerPopUp from "./customPopUp";
import saveLangChange from "./customLang";
import addAccordion from "./accordion";
import { initToggles, toggleHubMenus } from "./toggle";
import initSubmenuToggle from "./toggle-submenu";
import initWordsFlip from "./hero-flip-words";
import {
  initV2Modal,
  initV2ImgModal,
  initModalImgs,
  openModal,
} from "./modals";
import updateMenuDropdowns from "./menu-dropdowns";
import manipulateTabs from "./customTabs";
import { initImgSlider, initImgSliderAlt } from "./swiper";

saveLangChange();

initCalc();
triggerPopUp();
triggerLeavingPopUp();
addAccordion();
initToggles();
toggleHubMenus();
initSubmenuToggle();
initWordsFlip();
initV2Modal();
initV2ImgModal();
updateMenuDropdowns();
initImgSlider();
initImgSliderAlt();
initModalImgs();
openModal();

(function ($) {
  setTimeout(() => {
    const chatButton =
      document.getElementsByTagName("div")[
        document.getElementsByTagName("div").length - 1
      ];
    chatButton.parentElement.parentElement.style.zIndex = "3";
  }, 500);

  $(".ginput_container input, .ginput_container textarea").on(
    "input",
    function () {
      const field = $(this).closest(".gfield");
      if (this.value) {
        field.addClass("gfield--not-empty");
      } else {
        field.removeClass("gfield--not-empty");
      }
    }
  );

  if ($("[data-carousel]").length > 0) {
    imageCarousel();
  }

  if ($("#map").length > 0) {
    initMap();
  }

  scrollAnimations();

  if ($("#menu").length > 0 && $(window).width() >= 1180) {
    menuAnimation();
  } else if ($("#menu").length > 0 && $(window).width() < 1180) {
    $('[data-toggle-visibility="menu"]').on("click", function (e) {
      e.preventDefault();
      const dest = $(this).data("toggle-visibility");
      $(`#${dest}`).slideToggle();
    });
  }

  $(".c-accordion [data-toggle-visibility]").on("click", function (e) {
    e.preventDefault();
    const dest = $(this).data("toggle-visibility");

    $("[data-toggle-visibility]")
      .find($("#").data("toggle-visibility"))
      .slideUp();

    $(this).find(".c-accordion__heading__lead").toggleClass("hidden");

    $(`#${dest}`).slideToggle();

    const body = document.querySelector(".o-layout");

    if (body.classList.contains("c-updated-styles")) {
      if ($(this).find(".c-icon").length > 0) {
        if ($(this).find(".c-icon").hasClass("c-icon--maximizecross-rotated")) {
          $(this).find(".c-icon").removeClass("c-icon--maximizecross-rotated");
          $(this).find(".c-icon").addClass("c-icon--maximizecross");
        } else {
          $(this).find(".c-icon").addClass("c-icon--maximizecross-rotated");
          $(this).find(".c-icon").removeClass("c-icon--maximizecross");
        }
      }
    } else {
      if ($(this).find(".c-icon").length > 0) {
        if ($(this).find(".c-icon").hasClass("c-icon--minimizeline")) {
          $(this).find(".c-icon").removeClass("c-icon--minimizeline");
          $(this).find(".c-icon").addClass("c-icon--maximizecross");
        } else {
          $(this).find(".c-icon").addClass("c-icon--minimizeline");
          $(this).find(".c-icon").removeClass("c-icon--maximizecross");
        }
      }
    }

    $.scrollify.update();
  });

  let i = 2;
  $(".blog__load-more").on("click", function (e) {
    e.preventDefault();
    const fetchUrl = $(this).attr("href");

    $.ajax({
      url: fetchUrl,
      dataType: "html",
    })
      .done((responseText) => {
        const morePosts = $("<div>")
          .append(jQuery.parseHTML(responseText))
          .find(".c-blog > .c-blog__post");
        $(".c-blog").append(morePosts);
        i++;

        $(".blog__load-more").attr("href", (_, h) =>
          h.replace(/\d+\/$/, `${i}/`)
        );

        history.pushState(null, null, fetchUrl);
      })
      .fail(() => {
        $(".blog__load-more").remove();
      });
  });

  $(".js-sharer-link").on("click", function (event) {
    const link = $(this).attr("href");

    if (link.substr(0, 6) !== "mailto") {
      event.preventDefault();
      window.open(link, "", "width=850, height=470");
    }
  });

  if ($(window).width() > 1160) {
    $(window).scroll(() => {
      const lang = document.querySelector(".no-fadeout");

      if (!lang) {
        if ($(window).scrollTop() >= 10) {
          $(".c-header__body-languages").fadeOut(300);
        } else {
          $(".c-header__body-languages").fadeIn(300);
        }
      }
    });
  }

  function triggerV2Scrolled() {
    const isPresent = document.querySelector(".v2-header");
    if (!isPresent) {
      return;
    }

    if ($(window).width() > 1160) {
      $(window).scroll(() => {
        // const heroHeight = document.querySelector(".v2-hero").offsetHeight - 200;

        if ($(window).scrollTop() >= 100) {
          document.querySelector(".v2-header").classList.add("scrolled");
        } else {
          document.querySelector(".v2-header").classList.remove("scrolled");
        }
      });
    }
  }

  triggerV2Scrolled();

  function loadVideo() {
    const mobileVideoFile = $("#c-processing__video-file--mobile").val();
    const desktopVideoFile = $("#c-processing__video-file--desktop").val();

    const video = $(".c-processing__video video");

    if ($(window).width() <= 1160) {
      video.attr("src", mobileVideoFile);
    } else {
      video.attr("src", desktopVideoFile);
    }

    video.load();
  }

  loadVideo();

  function addBodyClass() {
    const isPresent = document.querySelector(".lightblue");
    if (!isPresent) {
      return;
    }

    if (document.querySelector(".c-hero").classList.contains("lightblue")) {
      document.body.classList.add("lightblue");
    }

    if (document.querySelector(".c-hero").classList.contains("lightblue")) {
      $(".logo-white").hide();
      $(".logo-dark").show();
    }
  }

  addBodyClass();

  manipulateTabs();

  $(document).on("gform_confirmation_loaded", function (e, form_id) {
    $("body").addClass("gravity-form-submitted");

    const fullstoryDiv = document.querySelector(".has-fullstory-attribute");

    if (fullstoryDiv) {
      const attribute = fullstoryDiv.dataset.fullstory;
      FS.event(attribute);
    }
  });
})(jQuery);

document.addEventListener("DOMContentLoaded", function () {
  var toggleButtons = document.querySelectorAll(".v3-toggle-content");

  toggleButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      var contentBlock = this.parentNode;
      var fullContent = contentBlock.querySelector(".full-content");
      var previewContent = contentBlock.querySelector(".preview-content");

      if (fullContent.style.display === "none") {
        fullContent.style.display = "block";
        previewContent.style.display = "none";
        this.classList.add("visible");
      } else {
        fullContent.style.display = "none";
        previewContent.style.display = "block";
        this.classList.remove("visible");
      }
    });
  });
});
